import { Component, ElementRef, OnInit, ViewChild, } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ValidationErrors, ValidatorFn, AbstractControl } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { PhpMailServiceService } from 'src/assets/php-mail-service.service';
import { MailService } from 'src/app/service/mail-service';
import { RecaptchaErrorParameters } from 'ng-recaptcha';
import Swal from 'sweetalert2'
import { RecaptchaComponent } from 'ng-recaptcha';

interface SendMailRequestModel {
    subject: string,
    body: string,
}

@Component({
    selector: 'app-contact',
    templateUrl: './contact.component.html',
    styleUrls: ['./contact.component.scss']
})

export class ContactComponent implements OnInit {
    file: any = null;
    contactForm: FormGroup;

    @ViewChild('main') main: ElementRef | any;
    @ViewChild('captchaRef') captchaRef: RecaptchaComponent;

    constructor(
        private formBuilder: FormBuilder,
        private titleService: Title,
        private router: Router,
        private phpMailService: PhpMailServiceService,
        private mailService: MailService
    ) { }

    ngOnInit() {
        this.titleService.setTitle('Contact Us');
        this.contactForm = this.formBuilder.group({
            firstName: ['', Validators.required],
            lastName: ['', Validators.required],
            position: ['', Validators.required],
            email: ['', [Validators.required, Validators.email, this.gmailValidator()]],
            contactNumber: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(10)]],
            location: ['', Validators.required],
            detail: ['', Validators.required],
            captchaResponse: [''],
        });
       
    }
    // siteKey: string = '6LdxvngqAAAAAFOADKeolidNF4kLddXzP19lALDf';
    siteKey: string = '6LdxvngqAAAAAFOADKeolidNF4kLddXzP19lALDf';
    clientsideResponse: any;
    ngAfterViewInit() {
        this.captchaRef.reset(); // Ensure reCAPTCHA is initialized
      }
    public resolved(captchaResponse: string): void {
        this.clientsideResponse = `${captchaResponse}`;
        // console.log(this.clientsideResponse);

    }

    captchaResponse: any;
    public onError(errorDetails: RecaptchaErrorParameters): void {
        this.captchaResponse += `ERROR; error details (if any) have been logged to console\n`;
        console.log(`reCAPTCHA error encountered; details:`, errorDetails);
        alert("testing")
    }
   
    onCaptchaExpired() {
        console.log("Testing");
        this.captchaRef.reset();
        this.clientsideResponse = '';
    
        
    }


    gmailValidator(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            const email = control.value;
            if (!email) {
                return { 'required': true };
            }

            if (email !== email.toLowerCase()) {
                return { 'uppercaseEmail': true };
            }
            const allowedDomains = ['gmail.com', 'yahoo.com', 'mail.com', 'email.com'];
            const isValidDomain = allowedDomains.some(domain => email.toLowerCase().endsWith(`@${domain}`));
            return isValidDomain ? null : { 'customEmailInvalid': true };
        };
    }

    sendMail(): void {
       
        if (this.contactForm.status=="INVALID") {
            Swal.fire({
                title: 'Info',
                text: 'Please fill out all required fields.',
                icon: 'info',
                confirmButtonText: 'OK',
                position: 'center', // You can change this to 'top', 'top-end', 'bottom', etc.

            });
            this.markFormGroupTouched(this.contactForm);

            return;
        }
        if (!this.clientsideResponse) {
            Swal.fire({
                title: 'Info',
                text: 'Please complete the CAPTCHA.',
                icon: 'info',
                confirmButtonText: 'OK',
                position: 'center', // You can change this to 'top', 'top-end', 'bottom', etc.

            });
            return;
        }
        else {

            const formData = this.contactForm.value;
            const htmlBody = `
      <style>
        * {
            box-sizing: border-box;
        }

        .icons-btn {
            width: 100px;
            height: 25px;
            margin-left: 70px;
            margin-right: 100x;


        }

        .variable {
            width: max-content;
        }

        .img-size {
            width: 25px;
            height: 25px;
        }

        body {
            margin: 0;
            padding: 0;
        }

        a[x-apple-data-detectors] {
            color: inherit !important;
            text-decoration: inherit !important;
        }

        #MessageViewBody a {
            color: inherit;
            text-decoration: none;
        }

        p {
            line-height: inherit
        }

        .desktop_hide,
        .desktop_hide table {
            mso-hide: all;
            display: none;
            max-height: 0px;
            overflow: hidden;
        }

        .image_block img+div {
            display: none;
        }

        @media (max-width:700px) {

            .desktop_hide table.icons-inner,
            .social_block.desktop_hide .social-table {
                display: inline-block !important;
            }

            .icons-inner {
                text-align: center;
            }

            .icons-inner td {
                margin: 0 auto;
            }


            .row-content {
                width: 100% !important;
            }

            .mobile_hide {
                display: none;
            }

            .stack .column {
                width: 100%;
                display: block;
            }

            .mobile_hide {
                min-height: 0;
                max-height: 0;
                max-width: 0;
                overflow: hidden;
                font-size: 0px;
            }

            .desktop_hide,
            .desktop_hide table {
                display: table !important;
                max-height: none !important;
            }

            .header-title {
                font-size: 14px !important;
            }

            .header-heading {
                font-size: 18px !important;
            }

            .header-content {
                font-size: 12px !important;
            }
            .header-spacing {
                line-height: 16px !important;
            }

            .box-content {
                height: 5px !important;
                margin: 8px 0 14px !important;
            }

            .logo-content {
                width: 220px;
                margin-left: 22%;
                margin-right: 50%;
            }

            .logo-content h4 {
                font-size: 46px !important;
                line-height: 1.3;
                margin-top: 11px !important;
                margin-bottom: -27px !important;
            }
            .logo-content h3 {
                font-size: 17px !important;
                line-height: 1.3;
                
            }
            .logo-content img {
                width: 102px !important;
                margin-left: -78px;
                
            }
            .table-cre{
                font-size: 14px !important;
            }
            .table-scale{
                padding-bottom: 4px !important;
                padding-top: 22px !important;
            }
            .text-content h3{
               font-size: 18px !important;

            }
            
            .text-content span{
               font-size: 27px !important;

                  }
               .pad{
               text-align: center
               }
            .footer2-content {
                font-size: 11px !important;
            }
        }
    </style>
      <body style="background-color: #f9f9f9; margin: 0; padding: 0; -webkit-text-size-adjust: none; text-size-adjust: none;">

      <table align="center" border="1px solid black" cellpadding="0" cellspacing="0" class="row-content stack"
          role="presentation"
          style="  mso-table-lspace: 0pt; mso-table-rspace: 0pt; background-color: #fff; color: #000000; width: 640px;"
          width="640">
          <tbody>
              <tr>
                  <td class="column column-1"
                      style="mso-table-lspace: 0pt; mso-table-rspace: 0pt; font-weight: 400; text-align: left; vertical-align: top; padding-top: 0px; padding-bottom: 0px; border-top: 0px; border-right: 0px; border-bottom: 0px; border-left: 0px;"
                      width="100%">
  
                      <table align="center" border="0" cellpadding="0" cellspacing="0" class="row row-1"
                          role="presentation" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt;" width="100%">
                          <tbody>
                              <tr>
                                  <td>
                                      <table align="center" border="0" cellpadding="0" cellspacing="0"
                                      class="row-content stack" role="presentation"
                                      style="mso-table-lspace: 0pt; mso-table-rspace: 0pt; background-color:#4C118E ; color: #000000; width: 680px;"
                                      width="680">
                                      <tbody>
                                          <tr>
                                              <td class="column column-1"
                                                  style="mso-table-lspace: 0pt; mso-table-rspace: 0pt; font-weight: 400; text-align: left; vertical-align: top; border-top: 0px; border-right: 0px; border-bottom: 0px; border-left: 0px;"
                                                  width="100%">
                                                  <table border="0" cellpadding="0" cellspacing="0"
                                                      class="image_block block-1" role="presentation"
                                                      style="mso-table-lspace: 0pt; mso-table-rspace: 0pt;"
                                                      width="100%">
                                                      <tbody>
                                                          <tr>
                                                              <td class="pad,  table-scale"
                                                                  style=" padding-bottom:18px;padding-top: 32px;width:100%;padding-right:0px;padding-left:0px;">
                                                                  <div align="center" class="alignment , logo-content"
                                                                      style="line-height:10px; ">
                                                                      <img alt="Yourlogo Light"
                                                                          src="https://vocbot.ai/assets/img/vocbot-logo-footer.jpeg"
                                                                          style="display: block; height: auto; border: 0; width: 146px; max-width: 100%;"
                                                                          title="Yourlogo Light" width="268">
                                                                     
                                                                  </div>
                                                            </td>
                                                          </tr>
                                                      </tbody>
                                                  </table>
                                              </td>
                                          </tr>
                                      </tbody>
                                  </table>
                                  </td>
                              </tr>
                          </tbody>
                      </table>
                      <table align="center" border="0" cellpadding="0" cellspacing="0" class="row row-2"
                          role="presentation" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt;" width="100%">
                          <tbody>
                              <tr>
                                  <td>
                                      <table cellspacing="0" border="0" cellpadding="0" width="100%" bgcolor="#F2F3F8"
                                          style="@import url(https://fonts.googleapis.com/css?family=Rubik:300,400,500,700%7COpen+Sans:300,400,600,700); font-family: 'Open Sans', sans-serif;">
                                          <tr>
                                              <td>
                                                  <table
                                                      style="background-color: #F2F3F8; max-width:670px; margin:0 auto;"
                                                      width="100%" border="0" align="center" cellpadding="0"
                                                      cellspacing="0">
                                                      <table align="center" border="0" cellpadding="0" cellspacing="0"
                                                          class="row-content stack" role="presentation"
                                                          style="mso-table-lspace: 0pt; mso-table-rspace: 0pt; background-color: #ffffff; color: #000000; border-radius: 0; width: 680px;"
                                                          width="680">
                                                          <tbody>
                                                              <tr>
                                                                  <td class="column column-1"
                                                                      style="mso-table-lspace: 0pt; mso-table-rspace: 0pt; font-weight: 400; text-align: left; padding-bottom: 5px; padding-top: 5px; vertical-align: top; border-top: 0px; border-right: 0px; border-bottom: 0px; border-left: 0px;"
                                                                      width="100%">
                                                                      <table border="0" cellpadding="0" cellspacing="0"
                                                                          class="image_block block-1" role="presentation"
                                                                          style="mso-table-lspace: 0pt; mso-table-rspace: 0pt;"
                                                                          width="100%">
                                                                          <tbody>
                                                                              <tr>
                                                                                  <td class="pad"
                                                                                      style="width:100%;padding-right:0px;padding-left:0px; ">
                                                                                      <div align="center"
                                                                                          class="alignment text-content"
                                                                                          style="line-height:10px">
                                                                                           <h3 style="color: #000; display: block; height: auto; border: 0;padding-top: 0px;  font-family: Poppins, sans-serif; font-size: 26px;
                                                                                              margin-top: 62px;
                                                                                                margin-bottom: 35px">
                                                                                                Welcome to <span style="font-weight: 800; font-size: 38px;">Vocbot.Ai!</span> </h3>
                                                                                          <img class="big"
                                                                                              src="https://vocbot.ai/assets/img/email.gif"
                                                                                              style="display: block; height: auto; border: 0; width: 296; max-width: 100%;margin-top: -30px;margin-bottom: -45px; ;"
                                                                                              width="150">
                                                                                      </div>
                                                                                  </td>
                                                                              </tr>
                                                                          </tbody>
                                                                      </table>
                                                                      <!-- Email Content -->
                                                              <tr>
                                                                  <td>
                                                                      <table width="100%" border="0" align="center"
                                                                          cellpadding="0" cellspacing="0">
                                                                          <tr>
                                                                              <td class="box-content"
                                                                                  style="height:15px;">&nbsp;</td>
                                                                          </tr>
                                                                          <!-- Title -->
                                                                        
  
                                                                          <!-- <table>
                                                                              <tbody>
                                                                                  <tr>
                                                                                      
  
  
                                                                                      <h1 class="header-content"
                                                                                          style="Padding-top: 10px; text-transform: uppercase; margin-bottom: -8px;margin-left: 10px;margin-right: 20px; letter-spacing: 0.04em; line-height: 1.5em; font-size: 18px;font-family: Poppins, sans-serif;  color: 455056; ">
                                                                                          Contact Form Submission :
                                                                                  </h1>
                                                                                  </tr>
                                                                              </tbody>
                                                                          </table> -->
  
                                                                          <!-- <tr>
                                                                              <td
                                                                                  style="padding:0 15px; text-align:left;  ">
                                                                                  <h3 class="header-title"
                                                                                      style="color:#4C118E ; font-weight:400; margin:0;MARGIN-LEFT: -7px;margin-top: 24px; margin-bottom: -18px; font-family: Poppins, sans-serif;">
                                                                                      <b>CREDENTIALS :</b>
                                                                                  </h3>
                                                                                  <span style="display:inline-block; vertical-align:middle; margin:13px 0 18px; border-bottom: 1px solid null ;width:100px;"></span>
                                                                              </td>
                                                                          </tr> -->
  
                                                                          <!-- Details Table -->
                                                                          <tr>
                                                                              <td>
                                                                                  <table cellpadding="0" cellspacing="0"
                                                                                      style="width: 100%; border: -1.5px solid #2e2222;border-radius: 12px; font-size: 15px; padding-left: 9px; padding-right: 9px; margin-top: 45px; ">
                                                                                      <tbody>
                                                                                          <tr>
                                                                                              <th colspan="2" class="table-cre"
                                                                                                  style="text-align: center;  color: #fff; background-color: #4C118E; padding: 10px;font-size: 19px; letter-spacing: 1px;">
                                                                                                  Contact Form Submission :
                                                                                              </th>
                                                                                          </tr>
                                                                                          <tr>
                                                                                              <td class="header-content"
                                                                                                  style="padding: 10px;background-color: #e6e6ff; border-bottom: 1px solid #bdbdbd; 
                                                                                                  border-radius: 3px 0px 0px 0px; border-right: 1px solid #bdbdbd; width: 35%; font-weight:500;font-family: Poppins, sans-serif;  color:rgba(0,0,0,.64)">
                                                                                                  <b> First Name:</b>
                                                                                              </td>
                                                                                              <td class="header-content"
                                                                                                  style="padding: 10px;border-radius: 0px 3px 0px 0px; background-color: #e6e6ff;border-bottom: 1px solid #bdbdbd; color: #455056; font-family: Poppins, sans-serif!important">
                                                                                                  ${formData.firstName}</td>
                                                                                          </tr>
                                                                                          <tr>
                                                                                              <td class="header-content"
                                                                                                  style="padding: 10px;background-color: #e6e6ff; border-bottom: 1px solid #bdbdbd; border-right: 1px solid #bdbdbd; width: 35%; font-weight:500;font-family: Poppins, sans-serif; color:rgba(0,0,0,.64);">
                                                                                                  <b> Last Name:</b>
                                                                                              </td>
                                                                                              <td class="header-content"
                                                                                                  style="padding: 10px;background-color: #e6e6ff; border-bottom: 1px solid #bdbdbd; color: #455056;">
                                                                                                  ${formData.lastName}</td>
                                                                                          </tr>
  
                                                                                          <tr>
                                                                                              <td class="header-content"
                                                                                                  style="padding: 10px; border-radius: 0px 0px 0px 3px; background-color: #e6e6ff; border-bottom: 1px solid #bdbdbd; border-right: 1px solid #bdbdbd; width: 35%; font-weight:500;font-family: Poppins, sans-serif;;color:rgba(0,0,0,.64);">
                                                                                                  <b>Position:</b>
                                                                                              </td>
                                                                                              <td class="header-content"
                                                                                                  style="padding: 10px; border-radius: 0px 0px 3px 0px; background-color: #e6e6ff; border-bottom: .2px solid #bdbdbd; color: #455056;">
                                                                                                  ${formData.position}</td>
                                                                                          </tr>
                                                                                          <tr>
                                                                                              <td class="header-content"
                                                                                                  style="padding: 10px; border-radius: 0px 0px 0px 3px; background-color: #e6e6ff; border-bottom: 1px solid #bdbdbd; border-right: 1px solid #bdbdbd; width: 35%; font-weight:500;font-family: Poppins, sans-serif;;color:rgba(0,0,0,.64);">
                                                                                                  <b>Email:</b>
                                                                                              </td>
                                                                                              <td class="header-content"
                                                                                                  style="padding: 10px; border-radius: 0px 0px 3px 0px; background-color: #e6e6ff; border-bottom: .2px solid #bdbdbd; color: #455056;">
                                                                                                  ${formData.email}</td>
                                                                                          </tr>
                                                                                          <tr>
                                                                                              <td class="header-content"
                                                                                                  style="padding: 10px; border-radius: 0px 0px 0px 3px; background-color: #e6e6ff; border-bottom: 1px solid #bdbdbd; border-right: 1px solid #bdbdbd; width: 35%; font-weight:500;font-family: Poppins, sans-serif;;color:rgba(0,0,0,.64);">
                                                                                                  <b>Contact Number:</b>
                                                                                              </td>
                                                                                              <td class="header-content"
                                                                                                  style="padding: 10px; border-radius: 0px 0px 3px 0px; background-color: #e6e6ff; border-bottom: .2px solid #bdbdbd; color: #455056;">
                                                                                                  ${formData.contactNumber}</td>
                                                                                          </tr>
                                                                                          <tr>
                                                                                              <td class="header-content"
                                                                                                  style="padding: 10px; border-radius: 0px 0px 0px 3px; background-color: #e6e6ff; border-bottom: 1px solid #bdbdbd; border-right: 1px solid #bdbdbd; width: 35%; font-weight:500;font-family: Poppins, sans-serif;;color:rgba(0,0,0,.64);">
                                                                                                  <b>Location:</b>
                                                                                              </td>
                                                                                              <td class="header-content"
                                                                                                  style="padding: 10px; border-radius: 0px 0px 3px 0px; background-color: #e6e6ff; border-bottom: .2px solid #bdbdbd; color: #455056;">
                                                                                                  ${formData.location}</td>
                                                                                          </tr>
                                                                                          <tr>
                                                                                              <td class="header-content"
                                                                                                  style="padding: 10px; border-radius: 0px 0px 0px 3px; background-color: #e6e6ff; border-bottom: 1px solid #bdbdbd; border-right: 1px solid #bdbdbd; width: 35%; font-weight:500;font-family: Poppins, sans-serif;;color:rgba(0,0,0,.64);">
                                                                                                  <b>Detail:</b>
                                                                                              </td>
                                                                                              <td class="header-content"
                                                                                                  style="padding: 10px; border-radius: 0px 0px 3px 0px; background-color: #e6e6ff; border-bottom: .2px solid #bdbdbd; color: #455056;">
                                                                                                  ${formData.detail}</td>
                                                                                          </tr>
                                                                                         
                                                                                         
                                                                                      </tbody>
                                                                                  </table>
                                                                              </td>
                                                                          </tr>
                                                                          <tr>
                                                                              <td
                                                                                  style="text-align:left; padding-top: 26px;  padding-bottom: 10px;">
                                                                                  <p class="header-content"
                                                                                      style="font-size:14px; color:#455056; line-height:18px; margin:0 0 0 ;font-family: Poppins, sans-serif;padding-left: 10px; line-height: 30px; font-size: 15px; letter-spacing: .3px;">
                                                                                      For more details
                                                                                      please <a
                                                                                          href="https://vocbot.ai/#/"
                                                                                          style="color: #7755ff;text-decoration-line: none;"
                                                                                          target="_blank">click
                                                                                          here
                                                                                      </a> and visit
                                                                                      portal.
                                                                                  </p>
                                                                                  <!-- <p class="header-content header-spacing"
                                                                                      style="font-size:14px; color:#455056; line-height:18px; margin:0 0 0;font-family: Poppins, sans-serif; padding-left: 10px ; line-height: 25px;font-size: 15px; letter-spacing: .3px;">
  
                                                                                      Best Regards,<br> Team Vocbot.Ai</p>
                                                                                  <br><span class="footer2-content"
                                                                                      style="color:rgb(100,101,103)!important; font-size: smaller;padding-left: 10px; ">
                                                                                      This email was generated on a
                                                                                      system. Please do not reply to this
                                                                                      email.
  
                                                                                  </span> -->
                                                                              </td>
                                                                          </tr>
                                                                      </table>
                                                                  </td>
                                                              </tr>
  
                                                      </table>
                                                      <!-- Additional content -->
  
                                              </td>
                                          </tr>
                                      </table>
                                     <table align="center" border="0" cellpadding="0" cellspacing="0"
                                        class="row-content stack" role="presentation"
                                        style="mso-table-lspace: 0pt; mso-table-rspace: 0pt; background-color: #4C118E ; color: #4C118E ; width: 680px;display: flex;justify-content: center "
                                        width="680">
                                        <tbody>
                                            <tr>
                                                <td>
                                                    <table align="center" border="0" cellpadding="0" cellspacing="0"
                                                        class="row-content stack" role="presentation"
                                                        style="transition: 0.3s; mso-table-lspace: 0pt; mso-table-rspace: 0pt; background-color: #4C118E ; color: #4C118E ; width: 640px;"
                                                        width="640">
                                                        <tbody>
                                                            <tr>
                                                                <td class="column column-1"
                                                                    style="mso-table-lspace: 0pt; mso-table-rspace: 0pt; font-weight: 400; text-align: left; vertical-align: top; padding-top: 0px; padding-bottom: 0px; border-top: 0px; border-right: 0px; border-bottom: 0px; border-left: 0px;"
                                                                    width="100%">
                                                                    <table border="0" cellpadding="0" cellspacing="0"
                                                                        class="image_block" role="presentation"
                                                                        style="mso-table-lspace: 0pt; mso-table-rspace: 0pt;"
                                                                        width="100%">
                                                                        <tbody>
                                                                            <tr>
                                                                                <td
                                                                                    style="width: 100%; padding-right: 0px; padding-left: 0px; background-color: #4C118E ; text-align: center;">
                                                                                    <div align="center"
                                                                                        style="margin-top: 20px; line-height: 12px; height: auto; width: 100%; background-color: #4C118E ; font-family: Montserrat, Trebuchet MS, Lucida Grande, Lucida Sans Unicode, Lucida Sans, Tahoma, sans-serif; margin-top: 40px;">
                                                                                        <p
																										style="font-size: 16px; text-align: center; color: #ffffff; line-height: 20px;">
																										<strong>Technical Partner </strong>
																									</p>
																									<p
																										style="font-size: 14px; color: #ffffff; line-height: 20px; font-size: 14px; text-align: center; font-family: Poppins, sans-serif;">

																										AMSTECH INCORPORATION
                                                                                            PRIVATE LIMITED <br>
																									</p>
                                                                                        <p
                                                                                            style="font-size: 16px; text-align: center;">
                                                                                            <span
                                                                                                style="font-size: 16px; color: #ffffff;"><strong>Disclaimer</strong></span>
                                                                                        </p>
                                                                                        <p
                                                                                            style="color: #d3d3d3;letter-spacing: .3px; font-size: 13px; padding-bottom: 5px; padding-left: 5px; padding-right: 5px; text-align: justify;font-family: Poppins, sans-serif;">
                                                                                            You are receiving this email
                                                                                            because this is
                                                                                            an important message
                                                                                            regarding Our Portal.
                                                                                            You are not allowed to
                                                                                            unsubscribe from this
                                                                                            type of message. This email
                                                                                            and any files
                                                                                            transmitted with it are
                                                                                            confidential and
                                                                                            intended solely for the use
                                                                                            of the individual
                                                                                            or entity to which they are
                                                                                            addressed. If you
                                                                                            have received this email in
                                                                                            error please
                                                                                            notify the system manager of
                                                                                            Our Portal. This
                                                                                            message contains
                                                                                            confidential information and
                                                                                            is intended only for the
                                                                                            individual named. If
                                                                                            you are not the named
                                                                                            addressee you should not
                                                                                            disseminate, distribute or
                                                                                            copy this e-mail.
                                                                                            Please notify the sender
                                                                                            immediately by e-mail
                                                                                            if you have received this
                                                                                            e-mail by mistake
                                                                                            and delete this e-mail from
                                                                                            your system. If
                                                                                            you are not the intended
                                                                                            recipient you are
                                                                                            notified that disclosing,
                                                                                            copying,
                                                                                            distributing, or taking any
                                                                                            action in reliance
                                                                                            on the contents of this
                                                                                            information is
                                                                                            strictly prohibited. The
                                                                                            information contained
                                                                                            in this mail is propriety
                                                                                            and strictly
                                                                                            confidential.</p>

                                                                                    </div>
                                                                                </td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                     
                                     <table align="center" border="0" cellpadding="0" cellspacing="0"
                                        class="row-content stack" role="presentation"
                                        style="mso-table-lspace: 0pt; mso-table-rspace: 0pt; background-color: #4C118E ; color: #4C118E ; width: 680px;display: flex;justify-content: center "
                                        width="680">

                                        <tbody>
                                            <tr>
                                                <td>

                                                    <p
                                                        style=" cursor: pointer;margin-right: 20px; color: white;position: relative; font-family: Arial, Helvetica Neue, Helvetica, sans-serif;font-weight: bolder;">
                                                        <a href="##facebookRedirectUrl##" target="_blank"
                                                            style="font-family:sans-serif, Helvetica Neue, Helvetica, sans-serif !important;line-height:120%;text-align:left;direction:ltr;letter-spacing:0px;mso-line-height-alt:18px;color: whitesmoke;font-size: 14px; text-decoration: none; align-items: center;">
                                                        </a>
                                                        + Facebook
                                                    </p>

                                                </td>
                                                <td>

                                                    <p
                                                        style="cursor: pointer; margin-right: 20px; color: white;position: relative;font-family: Arial, Helvetica Neue, Helvetica, sans-serif;font-weight: bolder;">
                                                        <a href="##twitterRedirectUrl##" target="_blank"
                                                            style="font-family:sans-serif, Helvetica Neue, Helvetica, sans-serif !important;line-height:120%;text-align:left;direction:ltr;letter-spacing:0px;mso-line-height-alt:18px;color: whitesmoke;font-size: 14px; text-decoration: none; ">
                                                        </a>
                                                        + Twitter
                                                    </p>

                                                </td>
                                                <td>

                                                    <p
                                                        style=" cursor: pointer;margin-right: 20px; color: white;position: relative;font-family: Arial, Helvetica Neue, Helvetica, sans-serif;font-weight: bolder;">
                                                        <a href="##instagramRedirectUrl##" target="_blank"
                                                            style="font-family:sans-serif, Helvetica Neue, Helvetica, sans-serif !important;line-height:120%;text-align:left;direction:ltr;letter-spacing:0px;mso-line-height-alt:18px;color: whitesmoke;font-size: 14px; text-decoration: none; ">
                                                        </a>
                                                        + Instagram
                                                    </p>

                                                </td>
                                                <td>

                                                    <p
                                                        style=" cursor: pointer;color: white;position: relative; font-family: Arial, Helvetica Neue, Helvetica, sans-serif;font-weight: bolder;">
                                                        <a href="##linkedInRedirectUrl##" target="_blank"
                                                            style="font-family:sans-serif, Helvetica Neue, Helvetica, sans-serif !important;line-height:120%;text-align:left;direction:ltr;letter-spacing:0px;mso-line-height-alt:18px;color: whitesmoke;font-size: 14px; text-decoration: none; ">
                                                        </a>
                                                        + LinkedIn
                                                    </p>

                                                </td>


                                            </tr>

                                        </tbody>
                                    </table>
                                </td>
                            </tr>
                        </tbody>
                    </table>
  
  
  </body>
      
      `;




            const sendMailRequestModel: SendMailRequestModel = {
                body: htmlBody,
                subject: "Contact Form"
            };

            // Send the email using your API
            this.mailService.sendMail(sendMailRequestModel).subscribe(
                (resp: any) => {

                    Swal.fire({
                        title: 'Success',
                        text: 'Thank you! Your message has been sent. Our team will get back to you soon.',
                        showDenyButton: false,
                        showCancelButton: false,
                        confirmButtonText: "ok",
                    }).then((result) => {
                        /* Read more about isConfirmed, isDenied below */
                        if (result.isConfirmed) {
                            window.location.reload();
                        }
                    });

                },
                (error) => {
                    console.error('Error:', error);
                    Swal.fire({
                        title: 'Error',
                        text: 'Sorry, there was an issue sending your message. Please try again later.',
                        icon: 'error',
                        confirmButtonText: 'OK',
                        position: 'center', // Position options: 'top', 'top-end', 'bottom', etc.
                    });
                }
            );
        }
    }

    get f() { return this.contactForm.controls; }



    onInputChange(event: any) {
        const inputValue = event.target.value;
        const numericValue = inputValue.replace(/\D/g, '');
        event.target.value = numericValue;
        this.contactForm.patchValue({ contactNumber: numericValue });
    }


    markFormGroupTouched(formGroup: FormGroup) {
        Object.values(formGroup.controls).forEach(control => {
            control.markAsTouched();

            if (control instanceof FormGroup) {
                this.markFormGroupTouched(control);
            }
        });
    }

}
